import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const convertToLocalTime = (utcDate, format = "DD/MM/YYYY hh:mm A") => {
  return dayjs.utc(utcDate).local().format(format);
};

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' }); // e.g. "Jun"
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

